import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ResearchTaskGroup = () => {
  const [teamData, setTeamData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/content/team.json')
      .then(res => res.json())
      .then(data => {
        setTeamData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading team data:', error);
        setLoading(false);
      });
  }, []);

  // Filter members who are in Research Task Group
  const getTaskGroupMembers = () => {
    if (!teamData.boardMembers) return [];

    const members = teamData.boardMembers.filter(member =>
      member.taskGroups && member.taskGroups.includes('Research Task Group')
    );

    // Sort so Rytis Pakrosnis comes first as he's mentioned first in the description
    return members.sort((a, b) => {
      if (a.name === 'Rytis Pakrosnis') return -1;
      if (b.name === 'Rytis Pakrosnis') return 1;
      return 0;
    });
  };

  // Filter members who are in Research Grant Committee
  const getGrantCommitteeMembers = () => {
    if (!teamData.boardMembers) return [];

    const members = teamData.boardMembers.filter(member =>
      member.taskGroups && member.taskGroups.includes('Research Grant Committee')
    );

    return members.sort((a, b) => {
      if (a.name === 'Rytis Pakrosnis') return -1;
      if (b.name === 'Rytis Pakrosnis') return 1;
      return 0;
    });
  };

  const memberCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    transition: 'all 0.3s ease'
  };

  const sectionStyle = {
    marginBottom: '3rem',
    padding: '2rem',
    backgroundColor: '#f8fafc',
    borderRadius: '16px',
    border: '1px solid #e2e8f0'
  };

  const activityCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    marginBottom: '1.5rem'
  };

  return (
    <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '2rem'}}>
      {/* Header */}
      <div style={{textAlign: 'center', marginBottom: '3rem'}}>
        <Link 
          to="/task-groups" 
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#2563eb',
            textDecoration: 'none',
            marginBottom: '1rem',
            fontSize: '1rem'
          }}
        >
          ← Back to Task Groups
        </Link>
        <h1 className="page-title" style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '1rem'}}>
          🔬 Research Task Group
        </h1>
        <p className="page-subtitle" style={{fontSize: '1.2rem', color: '#64748b', maxWidth: '800px', margin: '0 auto'}}>
          Supporting, promoting and disseminating research activities related to the Solution Focused approach
        </p>
      </div>

      {/* Mission */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🎯</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Our Mission</h2>
        </div>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
          The EBTA Research Task Group (EBTA RTG) sees itself as a platform in which research activities related to the SF approach converge 
          in order to support, promote and disseminate corresponding research activities.
        </p>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6'}}>
          We provide an overview of the areas in which the relevance and applicability of the SF approach is currently being tested and evaluated 
          and serve as an advisory body for member researchers of the SF approach.
        </p>
      </div>

      {/* Activities */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>📚</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Our Activities</h2>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '1.5rem'}}>
          
          {/* Publications List */}
          <div style={{...activityCardStyle, backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#059669'}}>📖</div>
              <h4 style={{color: '#166534', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>SFA PubList</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>
              Maintains the comprehensive list of publications on the SF approach (SFA PubList by EBTA) and conducts 
              occasional reviews of the research on the SF approach.
            </p>
            <Link 
              to="/sf-research"
              style={{
                color: '#059669',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '0.9rem'
              }}
            >
              View Publications →
            </Link>
          </div>

          {/* Research Support */}
          <div style={{...activityCardStyle, backgroundColor: '#f0f9ff', border: '1px solid #bfdbfe'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#2563eb'}}>🤝</div>
              <h4 style={{color: '#1e40af', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Research Support</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Provides support and consultations for researchers planning research on the SF approach. 
              We offer guidance on methodology, study design, and best practices for SF research.
            </p>
          </div>

          {/* Research Grant */}
          <Link 
            to="/research/grant"
            style={{
              ...activityCardStyle, 
              backgroundColor: '#fef3c7', 
              border: '1px solid #fde047',
              textDecoration: 'none',
              color: 'inherit',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#d97706'}}>🏆</div>
              <h4 style={{color: '#a16207', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>EBTA Research Grant</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>
              The EBTA Research Grant Committee evaluates applications and awards the annual EBTA Research Grant 
              to support innovative research in solution-focused brief therapy.
            </p>
            <div style={{
              color: '#d97706',
              fontSize: '0.9rem',
              fontWeight: '600',
              textAlign: 'right'
            }}>
              Learn more →
            </div>
          </Link>
        </div>
      </div>

      {/* Members */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>👥</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Task Group Members</h2>
        </div>
        
        {loading ? (
          <div style={{textAlign: 'center', padding: '2rem'}}>
            <p style={{color: '#6b7280', fontSize: '1.1rem'}}>Loading team members...</p>
          </div>
        ) : (
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem'}}>
            {getTaskGroupMembers().map((member, index) => (
              <div key={index} style={memberCardStyle}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  backgroundColor: '#f3f4f6',
                  margin: '0 auto 1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  color: '#6b7280',
                  backgroundImage: member.image ? `url(${member.image})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}>
                  {!member.image && '👤'}
                </div>
                <h3 style={{color: '#1e293b', fontSize: '1.3rem', fontWeight: '600', marginBottom: '1rem'}}>
                  {member.name}
                </h3>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Research Grant Committee */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🏆</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Research Grant Committee</h2>
        </div>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
          The EBTA RTG invites researchers who are involved in practice-relevant research to apply for the annual EBTA Research Grant.
          This is an opportunity to make your research project accessible to a broader interested professional audience, thereby contributing
          to the further development of the field and highlighting improvements made possible by solution-focused practices on a scientific basis.
        </p>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
          All types of research projects can be supported (quantitative and/or qualitative; clinical or non-clinical…), as long as they
          meet standards of quality and rigor. Good research is one thing and yet, the implementation of its results in real-life situations
          is quite another. In many areas of society (healthcare, administration, education, security, etc.) there is an increasing expectation
          not only to conduct research, but also to implement and apply the results in practice.
        </p>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
          The idea of the EBTA Research Grant was proposed by Steve de Shazer and agreed by the EBTA Board in 2000. Since then, nearly 25 grants
          have been awarded to research projects on the solution-focused approach and its applications.
        </p>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '2rem'}}>
          Applications are evaluated and the decisions on awarding the EBTA Research Grant are made by the Research Grant Committee of the
          EBTA Research Task Group, consisting of two-three members of the EBTA Research Task Group and two-three external academics
          (currently coordinated by Rytis Pakrosnis). More information and news on the EBTA Research Grant as well as the application form
          can be found on the{' '}
          <Link to="/research/grant" style={{color: '#2563eb', fontWeight: '600'}}>
            EBTA Research Grant page
          </Link>
          . We are looking forward to your applications!
        </p>

        <h3 style={{color: '#1e293b', fontSize: '1.3rem', fontWeight: '600', marginBottom: '1.5rem', marginTop: '2rem'}}>
          Committee Members
        </h3>
        {loading ? (
          <div style={{textAlign: 'center', padding: '1rem'}}>
            <p style={{color: '#6b7280', fontSize: '1.1rem'}}>Loading committee members...</p>
          </div>
        ) : (
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem'}}>
            {getGrantCommitteeMembers().map((member, index) => (
              <div key={index} style={memberCardStyle}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  backgroundColor: '#f3f4f6',
                  margin: '0 auto 1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  color: '#6b7280',
                  backgroundImage: member.image ? `url(${member.image})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}>
                  {!member.image && '👤'}
                </div>
                <h3 style={{color: '#1e293b', fontSize: '1.3rem', fontWeight: '600', marginBottom: '1rem'}}>
                  {member.name}
                </h3>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Contact & Support */}
      <div style={{...sectionStyle, backgroundColor: '#f1f5f9', textAlign: 'center'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>📧</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Get Involved</h2>
        </div>
        <p style={{fontSize: '1.1rem', color: '#64748b', marginBottom: '1.5rem', maxWidth: '600px', margin: '0 auto 1.5rem'}}>
          Interested in SF research or need support for your research project?
        </p>
        <p style={{fontSize: '1rem', color: '#64748b', marginBottom: '2rem'}}>
          Contact our Research Task Group for guidance and collaboration opportunities.
        </p>
        <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center'}}>
          <Link 
            to="/research/grant"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#2563eb',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1d4ed8';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#2563eb';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>🏆</span>
            Apply for EBTA Research Grant
          </Link>
          <Link 
            to="/contact"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#059669',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#047857';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#059669';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>📧</span>
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResearchTaskGroup;
